//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default{
      data(){
          return{
              demendDatas:[]
          }
      },
      methods:{
        goBack(){
          window.history.go(-1)
        },
        getDemendDetail(){
            var data = {
                id:this.$route.query.id
            }
            this.$https.post(this.BASE_URL+'pps/organization/fpWelfareDemandDetail',data).then(
                res => {
                    console.log(res);
                    if(res.data.code == 'PPSI0000'){
                        this.demendDatas.push(res.data.data);
                    }
                }
            ).catch(err => {
                console.log(err);
            })

        }
      },
      mounted(){
          console.log(this.$route.query.id)
          this.getDemendDetail();
      }
  }



// WEBPACK FOOTER //
// ./src/crowd_fund/socialOrgan/needsDetail.vue